var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    shapeRendering: "crispEdges",
    viewBox: "0 -0.5 32 32",
    style: {
      display: "inline-block",
      marginRight: 4,
      width: 32,
      height: 32
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M5 3h1m20 0h1M6 4h1m6 0h6m6 0h1M7 5h1m3 0h10m3 0h1M11 6h2m6 0h2M9 7h2m10 0h2M9 8h2m10 0h2M8 9h2m12 0h2M8 10h2m12 0h2M8 11h2m12 0h2M8 12h2m12 0h2M3 13h3m2 0h2m12 0h2m2 0h3M8 14h2m12 0h2M9 15h2m10 0h2M9 16h2m10 0h2m-13 1h2m8 0h2m-12 1h2m8 0h2m-11 1h2m6 0h2m-10 1h2m6 0h2m-10 1h2m6 0h2m3 0h1M8 22h1m3 0h1m6 0h1m5 0h1M7 23h1m4 0h2m4 0h2m6 0h1M6 24h1m5 0h2m4 0h2m7 0h1M5 25h1m6 0h2m4 0h2m-8 1h2m4 0h2m-7 1h2m2 0h2m-6 1h6m-4 1h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M13 6h2m-4 1h4m-4 1h3m-4 1h3m-3 1h3m-3 1h2m-2 1h2m-2 1h3m-3 1h3m-2 1h3m-3 1h3m-2 1h3m-3 1h3m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-1 1h1m-1 1h1m-1 1h1m-1 1h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0",
    d: "M15 6h4m-4 1h6m-7 1h7m-8 1h9m-9 1h9m-10 1h10m-10 1h10m-8 1h4m1 0h3m-8 1h4m1 0h3m-7 1h2m1 0h3m-6 1h2m1 0h3m-4 1h3m-4 1h4m-4 1h3m-3 1h3m-3 1h3m-3 1h3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "gray",
    d: "M13 13h1m4 0h1m-6 1h1m4 0h1m-5 1h1m2 0h1m-4 1h1m2 0h1m-3 1h2m-2 1h1m-1 1h1m-1 1h1m-1 1h1m-1 1h1m1 1h1m-1 1h1m-1 1h1m-1 1h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "silver",
    d: "M15 23h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.76e59fae5406de34d32c3e2cde3b083b.svg";
export { ForwardRef as ReactComponent };